import React from 'react';
import PreviousStep from './previous';
import CurrentStep from './current';
import NextStep from './next';
import classNames from 'classnames';

export type Url = {
	link: string;
	label: string;
};

export interface PizzaTrackerProps {
	urls: Url[];
	current: number;
}

export const PizzaTracker = ({
	urls,
	current
}: PizzaTrackerProps) => {
	return (
		<nav aria-label="Progress">
            <ol role="list" className="flex items-center">
                {urls.map((url: Url, key: number) => (
                    <li key={key} className={classNames(key !== urls.length - 1 ? 'pr-16 md:pr-36' : '', 'relative')}>
                        { key < current 
                          ? (
                              <PreviousStep url={url} />
                            )
                          : key === current 
                          ? (
                              <CurrentStep url={url} />
                            ) 
                          : (
                              <NextStep url={url} /> 
                            )
                        }
                    </li>
                ))}
		    </ol>
        </nav>
	);
};
